import { useState } from "react";
import Modal from "../reusable_components/Modal";
import postData from "../custom_functions/postData";
import { url, validCurrency } from "../utils/config";
import Input from "../reusable_components/Input";
import Select from "../reusable_components/Select";
import { toast } from "react-toastify";
import currency from "../utils/currency";
import Button from "../reusable_components/Button";
import validateImageDimension from "../custom_functions/validateImageDimension";
import { btnCancel, btnOne, btnTwo, inputStyle, label, modalContainer, modalTitle, title } from "../utils/style";


function AddSubscription(props) {
    const [formData, setFormData] = useState({})
    const [missingFields, setMissingFields] = useState([]);
    const [inputErrors, setInputErrors] = useState([]);
    const [logoImage, setLogoImage] = useState({});
    const [logoImageUrl, setLogoImageUrl] = useState('');
    const [showInputError, setShowInputError] = useState(false);

    const countryList = ['USA', 'CANADA'];
    const requiredFields = ['name', 'price', 'validity', 'freeVisits', 'country', 'logoImage', 'currency']

    function updateFormData(e) {
        const { name, value } = e.target;
        const data = { ...formData };
        data[name] = value;
        setFormData(data);
    }

    function selectImage(e) {
        const file = e.target.files[0];
        validateImageDimension(
            file,
            () => {
                toast.error('Image dimension should be between 256x256 and 720x720!', { autoClose: 3000 })
            },
            () => {
                setLogoImage(file);
                setLogoImageUrl(URL.createObjectURL(file));
            }
        );

    }

    function addSubscription() {
        if (
            formData.name && formData.name.length !== 0 &&
            formData.price && formData.price >= 0 &&
            formData.validity && formData.validity >= 0 &&
            formData.freeVisits && formData.freeVisits >= 0 &&
            formData.country && countryList.includes(formData.country) &&
            logoImage &&
            !inputErrors.includes('error')
        ) {
            console.log('Validated');
            const data = new FormData();
            data.append('image', logoImage);
            Object.keys(formData).forEach(fd => {
                data.append(fd, formData[fd])
            })
            postData(`${url}/subscription`, data, (error) => {
                toast.error(error.response.data.message, { autoClose: 3000 })
            }, (data) => {
                toast.success(data.message, { autoClose: 3000 })
                props.setShowForm(false)
                props.reload(1 + Math.random())
            })
        } else {
            let fields = Object.keys(formData);
            let miss = [];
            if (fields.length !== requiredFields.length) {
                requiredFields.forEach(field => {
                    if (!fields.includes(field)) {
                        miss.push(field)
                    }
                })
            };
            setMissingFields(miss);
            setShowInputError(true)
        }
    }

    return (
        <div className={modalContainer}>
            <div className="bg-white w-2/3 px-8 pt-8 pb-4 rounded-lg">
                <div className={modalTitle}>ADD SUBSCRIPTION</div>
                <div>
                    <div className="grid grid-cols-6 gap-4 py-1 px-2">
                        <label className={label}>Subscription Name</label>
                        <div className="col-span-2">
                            <Input
                                index={0}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="name"
                                type='text'
                                maxLength='255'
                                value={formData.name}
                                className={inputStyle}
                                placeHolder="Enter Subscription Name"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <label className={label}>Price</label>
                        <div className="col-span-2">
                            <Input
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="price"
                                type='number'
                                min={0}
                                value={formData.price}
                                className={inputStyle}
                                placeHolder="Enter Price"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-6 gap-4 py-1 px-2">
                        <label className={label}>Validity</label>
                        <div className="col-span-2">
                            <Input
                                index={2}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="validity"
                                type='number'
                                min={1}
                                value={formData.validity}
                                className={inputStyle}
                                placeHolder="Enter Validity in Days"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <label className={label}>Free Visits</label>
                        <div className="col-span-2">
                            <Input
                                index={3}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                min={1}
                                name="freeVisits"
                                type='number'
                                value={formData.freeVisits}
                                className={inputStyle}
                                placeHolder="Enter Free Visits"
                                onChange={e => updateFormData(e)}
                            />
                        </div>

                    </div>
                    <div className="grid grid-cols-6 gap-4 py-1 px-2">
                        <label className={label}>Add-Ons</label>
                        <div className="col-span-2">
                            <Input
                                index={4}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                maxLimit={255}
                                name="addOns"
                                type='text'
                                value={formData.addOns}
                                className={inputStyle}
                                placeHolder="Enter Free Visits"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <label className={label}>Country</label>
                        <div className="col-span-2">
                            <Select
                                index={5}
                                setInputErrors={setInputErrors}
                                inputErrors={inputErrors}
                                name="country"
                                required={true}
                                options={countryList}
                                placeHolder='Country'
                                className={inputStyle}
                                missingFields={missingFields}
                                onChange={e => updateFormData(e)}
                                value={formData.country}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-6 gap-4 py-1 px-2">
                        <label className={label}>Currency</label>
                        <div className="col-span-2">
                            <Select
                                index={5}
                                setInputErrors={setInputErrors}
                                inputErrors={inputErrors}
                                name="currency"
                                required={true}
                                options={currency}
                                validCurrency={validCurrency}
                                placeHolder='Currency'
                                className={inputStyle}
                                missingFields={missingFields}
                                onChange={e => updateFormData(e)}
                                value={formData.currency}
                            />
                        </div>
                        <label className={label}>Subscription Logo</label>
                        <div className="col-span-2">
                            <Input
                                id={'logoImage'}
                                index={3}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                min={1}
                                name="logoImage"
                                type='file'
                                className="hidden"
                                placeHolder="Enter Free Visits"
                                onChange={e => selectImage(e)}
                            />
                            {
                                logoImageUrl.length === 0 ?
                                    <div className="py-3 flex justify-center">
                                        <label htmlFor="logoImage" className={btnTwo}>Select Logo</label>
                                    </div>
                                    :
                                    <div className="px-3 flex justify-center">
                                        <img src={logoImageUrl} width={'50px'} height={'50px'} />
                                    </div>
                            }
                        </div>
                    </div>


                    <div className="flex justify-between py-3 px-16 gap-8">
                        <button onClick={e => props.setShowForm(false)} className={btnCancel}>Cancel</button>
                        <Button clickHandler={e => addSubscription()} className={btnOne} name={'Submit'} />
                    </div>
                    <div className="text-red-500 font-semibold text-center">
                        {
                            showInputError && 'Please fill all the fields as directed!'
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddSubscription;